import { FAQNested } from "@vega-core/components/FAQ/FAQNested";

import { type FAQSection } from "../types/faq";

type Props = {
  sections: FAQSection[];
  openSectionIndex: number | undefined;
  onToggleSection: (index: number | undefined) => void;
};

export const ResourcesFaqs = ({
  sections,
  openSectionIndex,
  onToggleSection,
}: Props) => (
  <div>
    {sections.map((section, index) => (
      <div id={`faq-section-${section.value}`} key={section.value}>
        <FAQNested
          data={section.items}
          enableHashHighlight
          isOpen={openSectionIndex === index}
          listIndex={index}
          onToggle={(isOpen) => onToggleSection(isOpen ? index : undefined)}
          openList={openSectionIndex}
          setOpenList={onToggleSection}
          title={section.title}
          value={section.value}
        />
      </div>
    ))}
  </div>
);
